// extracted by mini-css-extract-plugin
export default {"title":"CaseStudiesPage1_title__o+1vY","overlay":"CaseStudiesPage1_overlay__-dvBq","container":"CaseStudiesPage1_container__TwLC1"};